export const APP_ENABLED = 'enabled';
export const APP_DISABLED = 'disabled';

export const APPCUES_IOS_SDK = 'https://github.com/appcues/appcues-ios-sdk';
export const APPCUES_ANDROID_SDK =
  'https://github.com/appcues/appcues-android-sdk';

export const getPlatformData = platform => {
  switch (platform) {
    case 'ios':
      return {
        platformIcon: ['fab', 'apple'],
        platformName: 'iOS',
        platformAppLabel: 'App bundle ID',
        sdkUrl: APPCUES_IOS_SDK,
      };
    case 'android':
      return {
        platformIcon: ['fab', 'android'],
        platformName: 'Android',
        platformAppLabel: 'App package ID',
        sdkUrl: APPCUES_ANDROID_SDK,
      };
    default:
      return {};
  }
};

export const PLATFORM_OPTIONS = [
  {
    label: 'iOS',
    value: 'ios',
  },
  {
    label: 'Android',
    value: 'android',
  },
];
